export default __webpack_public_path__ + "static/media/eb-arrow.6adf1cf7.svg";